// extracted by mini-css-extract-plugin
export default {"root":"page-inner_root_GTd7y","loaderWrapper":"page-inner_loaderWrapper_STFFZ"};